import React from "react";
import "./WhyChoose.css";

function WhyChoose() {
  const reasons = [
    {
      number: "01",
      title: "Industry Expertise",
      image: "/images/Offshore Diver.webp",
      description:
        "Deep industry knowledge and practical experience across energy, maritime and related operations.",
    },
    {
      number: "02",
      title: "Safety First",
      image: "/images/Industrial Safety Briefing.png",
      description:
        "Safety remains at the heart of how we plan, execute and deliver every operation.",
    },
    {
      number: "03",
      title: "Operational Excellence",
      image: "/images/operational excellence.webp",
      description:
        "We focus on efficient processes, dependable execution and consistently high standards.",
    },
    {
      number: "04",
      title: "Trusted Partnership",
      image: "/images/Logo Circle.webp",
      description:
        "We work closely with our clients to understand their needs and deliver solutions that create lasting value.",
    },
  ];

  return (
    <section className="why-choose" id="why-choose">

      <div className="why-choose-container">

        {/* ==================================================
            HEADER
            ================================================== */}

        <div className="why-choose-header">

          <div className="why-choose-heading">

            <span className="why-choose-eyebrow">
              WHY STRIDES
            </span>

            <h2>
              Built on
              <br />
              <span>Trust & Excellence.</span>
            </h2>

          </div>

          <div className="why-choose-intro">

            <p>
              We bring together people, expertise and
              technology to deliver dependable solutions
              for complex energy and maritime operations.
            </p>

          </div>

        </div>


        {/* ==================================================
            REASONS
            ================================================== */}

        <div className="why-choose-grid">

          {reasons.map((reason) => (

            <div
              className={`why-choose-card why-choose-card-${reason.number}`}
              key={reason.number}
            >
              <div className="why-choose-card-number" aria-hidden="true">
                &nbsp;
              </div>

              {reason.image ? (
                <img
                  src={reason.image}
                  alt=""
                  className="why-choose-card-icon why-choose-card-image"
                />
              ) : (
                <span
                  className={`why-choose-card-icon why-choose-card-icon-${reason.number}`}
                  aria-hidden="true"
                >
                  {reason.icon}
                </span>
              )}

              <div className="why-choose-card-content">

                <h3>
                  {reason.title}
                </h3>

                <p>
                  {reason.description}
                </p>

              </div>

              <div className="why-choose-card-line"></div>

            </div>

          ))}

        </div>


        {/* ==================================================
            BOTTOM STATEMENT
            ================================================== */}

        <div className="why-choose-bottom">

          <span className="why-choose-bottom-line"></span>

          <p>
            <strong>One team.</strong> One standard.
            A commitment to getting it right.
          </p>

        </div>

      </div>

    </section>
  );
}

export default WhyChoose;